/**
 * Hook for managing grant and revoke access mutations
 * Consolidates mutation logic with proper error handling
 */

import React from "react";
import { useGrantEmployeeAccess, useRevokeEmployeeAccess } from "@/lib/hooks/api/admin";
import type { GrantAccessMutationParams, RevokeAccessMutationParams } from "@/lib/types/grant-access";

export function useGrantAccessMutationHook() {
  const grantAccessMutation = useGrantEmployeeAccess();
  const revokeAccessMutation = useRevokeEmployeeAccess();

  const grantAccessToMultiple = React.useCallback(
    async (clientIds: string[], userId: string) => {
      return Promise.all(
        clientIds.map((contactId: string) =>
          grantAccessMutation.mutateAsync({
            userId,
            contactId,
          })
        )
      );
    },
    [grantAccessMutation]
  );

  const revokeAccess = React.useCallback(
    async (params: RevokeAccessMutationParams) => {
      return revokeAccessMutation.mutateAsync(params);
    },
    [revokeAccessMutation]
  );

  return {
    grantAccessMutation,
    revokeAccessMutation,
    grantAccessToMultiple,
    revokeAccess,
  };
}
